module.exports = __webpack_public_path__ + "static/divas2-fe98543345c838003f491847f6bf47fb.jpg";